module.exports = __webpack_public_path__ + "img/garden_ylqc_1.83298c6e.png";